export const INDUSTRY_MASTER = [
  { id: "ind-1", name: "Accounting / Auditing", isActive: true },
  { id: "ind-2", name: "Advertising & Marketing", isActive: true },
  { id: "ind-3", name: "Agriculture / Forestry / Fishing", isActive: true },
  { id: "ind-4", name: "Analytics / KPO / Research", isActive: true },
  { id: "ind-5", name: "Animation & VFX", isActive: true },
  { id: "ind-6", name: "Architecture / Interior Design", isActive: true },
  { id: "ind-7", name: "Auto components", isActive: true },
  { id: "ind-8", name: "Automobile", isActive: true },
  { id: "ind-9", name: "Aviation", isActive: true },
  { id: "ind-10", name: "Banking", isActive: true },
  { id: "ind-11", name: "Beverages", isActive: true },
  { id: "ind-12", name: "Biotechnology", isActive: true },
  { id: "ind-13", name: "BPO / Call centre", isActive: true },
  { id: "ind-14", name: "Building materials", isActive: true },
  { id: "ind-15", name: "Chemicals", isActive: true },
  {
    id: "ind-16",
    name: "Clinical Research / Contract Research",
    isActive: true,
  },
  { id: "ind-17", name: "Consumer Electronics & Appliances", isActive: true },
  { id: "ind-18", name: "Courier & Logistics", isActive: true },
  { id: "ind-19", name: "Defence and Aerospace", isActive: true },
  { id: "ind-20", name: "Design", isActive: true },
  { id: "ind-21", name: "Education / Training", isActive: true },
  { id: "ind-22", name: "E-Learning / Ed Tech", isActive: true },
  { id: "ind-23", name: "Electrical Equipment", isActive: true },
  {
    id: "ind-24",
    name: "Electronic Component / Semiconductors",
    isActive: true,
  },
  { id: "ind-25", name: "Electronics Manufacturing", isActive: true },
  { id: "ind-26", name: "Emerging Technologies", isActive: true },
  { id: "ind-27", name: "Engineering and construction", isActive: true },
  { id: "ind-28", name: "Events & Live Entertainment", isActive: true },
  { id: "ind-29", name: "Facility Management Services", isActive: true },
  {
    id: "ind-30",
    name: "Fertilisers / Pesticides / Agrochemicals",
    isActive: true,
  },
  { id: "ind-31", name: "Film / Music / Entertainment", isActive: true },
  { id: "ind-32", name: "FinTech / Payments", isActive: true },
  { id: "ind-33", name: "Financial Services", isActive: true },
  { id: "ind-34", name: "Fitness & Wellness", isActive: true },
  { id: "ind-35", name: "FMCG", isActive: true },
  { id: "ind-36", name: "Food Processing", isActive: true },
  { id: "ind-37", name: "Gaming", isActive: true },
  { id: "ind-38", name: "Gems & Jewellery", isActive: true },
  { id: "ind-39", name: "Government / Public Administration", isActive: true },
  { id: "ind-40", name: "Hardware and Networking", isActive: true },
  { id: "ind-41", name: "Hotels & Restaurants", isActive: true },
  { id: "ind-42", name: "Import & Export", isActive: true },
  { id: "ind-43", name: "Industrial Automation", isActive: true },
  { id: "ind-44", name: "Industrial Equipment / Machinery", isActive: true },
  { id: "ind-45", name: "Insurance", isActive: true },
  { id: "ind-46", name: "Internet", isActive: true },
  {
    id: "ind-47",
    name: "Investment Banking / Venture Capital / Private Equity",
    isActive: true,
  },
  { id: "ind-48", name: "Iron and Steel", isActive: true },
  { id: "ind-49", name: "IT Services and consulting", isActive: true },
  { id: "ind-50", name: "Law Enforcement / Security", isActive: true },
  { id: "ind-51", name: "Leather", isActive: true },
  { id: "ind-52", name: "Legal", isActive: true },
  { id: "ind-53", name: "Management consulting", isActive: true },
  { id: "ind-54", name: "Medical Devices and Equipment", isActive: true },
  { id: "ind-55", name: "Medical Services / Hospitals", isActive: true },
  { id: "ind-56", name: "Metals and Mining", isActive: true },
  { id: "ind-57", name: "NBFC", isActive: true },
  {
    id: "ind-58",
    name: "NGO / Social Services / Industry Associations",
    isActive: true,
  },
  { id: "ind-59", name: "Oil and Gas", isActive: true },
  { id: "ind-60", name: "Packaging and Containers", isActive: true },
  {
    id: "ind-61",
    name: "Petrochemicals / Plastics and Rubber",
    isActive: true,
  },
  { id: "ind-62", name: "Pharmaceuticals / Life Sciences", isActive: true },
  { id: "ind-63", name: "Ports and Shipping", isActive: true },
  { id: "ind-64", name: "Power", isActive: true },
  { id: "ind-65", name: "Printing and Publishing", isActive: true },
  { id: "ind-66", name: "Railways", isActive: true },
  { id: "ind-67", name: "Real Estate", isActive: true },
  { id: "ind-68", name: "Recruitment / Staffing", isActive: true },
  { id: "ind-69", name: "Retail", isActive: true },
  { id: "ind-70", name: "Software Product", isActive: true },
  { id: "ind-71", name: "Telecom / ISP", isActive: true },
  { id: "ind-72", name: "Textile & Apparel", isActive: true },
  { id: "ind-73", name: "Travel & Tourism", isActive: true },
  { id: "ind-74", name: "TV and Radio", isActive: true },
  { id: "ind-75", name: "Water Treatment / Waste Management", isActive: true },
  { id: "ind-76", name: "Others", isActive: true },
];

export function resolveIndustryId(nameOrId) {
  if (!nameOrId) return "ind-49";
  const foundById = INDUSTRY_MASTER.find((i) => i.id === nameOrId);
  if (foundById) return foundById.id;
  const foundByName = INDUSTRY_MASTER.find(
    (i) => i.name.toLowerCase() === nameOrId.trim().toLowerCase(),
  );
  return foundByName ? foundByName.id : "ind-76";
}

export function resolveIndustryName(idOrName) {
  if (!idOrName) return "IT Services and consulting";
  const foundById = INDUSTRY_MASTER.find((i) => i.id === idOrName);
  if (foundById) return foundById.name;
  const foundByName = INDUSTRY_MASTER.find(
    (i) => i.name.toLowerCase() === idOrName.trim().toLowerCase(),
  );
  return foundByName ? foundByName.name : idOrName;
}
